import { HttpClient } from "@angular/common/http";
import {
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
declare var google: any;


@Component({
  selector: 'sm-edit-member-address',
  templateUrl: './edit-member-address.component.html',
  styleUrls: ['./edit-member-address.component.scss']
})
export class EditMemberAddressComponent implements OnInit {
  apisub:Subscription
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    public _snackBar: MatSnackBar,
    public _ngZone: NgZone,
    private _apiService: ApiService,
    private http: HttpClient,
    private fb: FormBuilder,
    public _modelRef: MatDialog,
    private loader: LoaderServiceService,
    private router: Router,
    private activemodal: MatDialogRef<EditMemberAddressComponent>,
  ) {
 setTimeout(() => {
      if (
        typeof google === "undefined" ||
        !google.maps ||
        !google.maps.places
      ) {
        console.error("Google Maps API failed to load in Safari <15.");
        return;
      }

      this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
      this.geocoder = new google.maps.Geocoder();
    }, 500);
  this.apisub = this._apiService.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_EDIT_MEMBER_ADDRESS){
        if(resdata.result){
          this.activemodal.close({msg:'success'})
        }
      }
    })

  }

  ngOnInit(): void {
    this.houseNumber = this.parentdata.addressInfo.house_no;
    this.streetName = this.parentdata.addressInfo.street_name;
    this.landmark = this.parentdata.addressInfo.landmark;
    this.phone = this.parentdata.addressInfo.phone;
    this.selectedCountryCode = this.countryList.find(
      (country) =>
        country.dial_code === this.parentdata.addressInfo.country_code,
    );
    this.formattedAddress = this.parentdata.addressInfo.address_line;
    this.selectedLocation.city = this.parentdata.addressInfo.city;
    this.selectedLocation.state = this.parentdata.addressInfo.state;
    this.selectedLocation.country = this.parentdata.addressInfo.country;
    this.selectedLocation.zip = this.parentdata.addressInfo.zip;
    this.lat = this.parentdata.addressInfo.lat;
    this.lng = this.parentdata.addressInfo.lng;

    setTimeout(() => {
      this.initializeMap(
        {
          latitude: this.lat,
          longitude: this.lng,
        },
        this.formattedAddress,
      );
    }, 1);
  }

  // -------------------- MAP THINGS ---------------------------
  countryInfo: any =
    typeof sessionStorage.getItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
    ) == "string"
      ? JSON.parse(
          sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
          )!,
        )
      : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT);
  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) => country.dial_code === "+91",
  );
  searchString: FormControl = new FormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  @ViewChild("mapContainer", { static: false }) mapContainer!: ElementRef;
  contactselectedCountryCode: any = this.countryList.find(
    (country) =>
      country.dial_code === this.countryInfo.countryCode &&
      country.code === this.countryInfo.code,
  );
  houseNumber: any;
  streetName: any;
  landmark: any;
  phone: any;
  map!: google.maps.Map;
  marker!: google.maps.Marker;
  geocoder!: google.maps.Geocoder;
  lat: any;
  lng: any;
  initializeMap(address?: any, description?: any) {
    let mapOptions: google.maps.MapOptions;

    if (address && address.latitude && address.longitude) {
      this.lat = address.latitude;
      this.lng = address.longitude;
      mapOptions = {
        center: new google.maps.LatLng(address.latitude, address.longitude),
        zoom: 12,
      };
    } else {
      mapOptions = {
        center: new google.maps.LatLng(28.6139298, 77.2088282), // fallback (Delhi for example)
        zoom: 5,
      };
    }

    this.map = new google.maps.Map(this.mapContainer.nativeElement, mapOptions);

    // Create marker only if coordinates exist
    if (address && address.latitude && address.longitude) {
      this.marker = new google.maps.Marker({
        map: this.map,
        draggable: true,
        position: mapOptions.center,
      });

      this.geocoder = new google.maps.Geocoder();
      const latLng = new google.maps.LatLng(
        address.latitude,
        address.longitude,
      );
      this.geocodePosition(latLng, description);

      google.maps.event.addListener(this.marker, "dragend", (event: any) => {
        this.geocodePositionOverwrite(event.latLng);
      });
    }
  }

  // this.storeLocation( results[ 0 ].address_components, results[ 0 ].formatted_address );
  geocodePosition(latLng: google.maps.LatLng, description?: any) {
    console.log(latLng);
    console.log(description);

    this.geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          console.log(results[0]);
          // this.autocomplete.nativeElement.value = results[0].formatted_address;
          console.log("Address:", results[0].formatted_address);
          this.storeLocation(
            results[0].address_components,
            results[0].formatted_address,
            description ? description : results[0].formatted_address,
          );
          const location = results[0].geometry.location;
          this.lat = location.lat().toFixed(6);
          this.lng = location.lng().toFixed(6);
          console.log(this.lat, this.lng);
        } else {
          console.log("No results found");
        }
      } else {
        console.log("Geocoder failed due to:", status);
      }
    });
  }
  geocodePositionOverwrite(latLng: google.maps.LatLng) {
    console.log(latLng);

    this.geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          console.log(results[0]);
          // this.autocomplete.nativeElement.value = results[0].formatted_address;
          console.log("Address:", results[0].formatted_address);
          this.storeLocation(
            results[0].address_components,
            results[0].formatted_address,
            results[0].formatted_address,
          );
          const location = results[0].geometry.location;
          this.lat = location.lat().toFixed(6);
          this.lng = location.lng().toFixed(6);
        } else {
          console.log("No results found");
        }
      } else {
        console.log("Geocoder failed due to:", status);
      }
    });
  }

  // async getCurrentLocation(): Promise<any> {
  //   return new Promise(async (resolve, reject) => {
  //     if ('geolocation' in navigator) {
  //       navigator.geolocation.getCurrentPosition(
  //         async position => {
  //           const { latitude, longitude } = position.coords;
  //           try {
  //             resolve({ latitude, longitude});
  //           } catch (error) {
  //             reject('Error getting location info');
  //           }
  //         },
  //         error => reject(error)
  //       );
  //     } else {
  //       reject('Geolocation is not supported by your browser.');
  //     }
  //   });
  // }

  // async getCurrentLocation(): Promise<any> {
  //   try {
  //     const position = await Geolocation.getCurrentPosition();
  //     const coords = position.coords;
  //     console.log(JSON.stringify(position));

  //     return {
  //       latitude: coords.latitude.toString(),
  //       longitude: coords.longitude.toString(),
  //     };
  //   } catch (err) {
  //     console.error("Error fetching location", err);
  //     throw err;
  //   }
  // }
  location: any = "";
  targetaddress: any = "";
  selectedLocation: any = {};
  formattedAddress: any;
  storeLocation(location: any, formatted_address: any, description: any) {
    console.log(location);
    let address: any = {
      latitude: "",
      longitude: "",
      city: "",
      state: "",
      country: "",
      sublocality_level_1: "",
      zip: "",
    };

    location?.forEach((data: any) => {
      let type = data.types[0];
      console.log(type);
      if (type === "postal_code") {
        address.zip = data.long_name;
      } else if (type === "locality") {
        address.city = data.long_name;
      } else if (type === "administrative_area_level_1") {
        address.state = data.long_name;
      } else if (type === "country") {
        address.country = data.long_name;
      } else if (data.types.includes("sublocality_level_1")) {
        address.sublocality_level_1 = data.long_name;
      }
    });

    console.log(address);

    // ---------- ASSIGN TO KEYWORD ---------------

    const addressComponents = location || [];
    const priorityMap: any = {
      locality: null,
      administrative_area_level_1: null,
      country: null,
    };

    // Extract values based on priority
    addressComponents.forEach((data: any) => {
      const type = data.types[0];
      if (type in priorityMap && !priorityMap[type]) {
        priorityMap[type] = data.long_name;
      }
    });

    // Assign location based on priority
    this.location =
      priorityMap.locality ||
      priorityMap.administrative_area_level_1 ||
      priorityMap.country;

    address.latitude = this.lat ?? "";
    address.longitude = this.lng ?? "";
    address.formatted_address = description ?? "";

    this.selectedLocation = address;
    console.log(this.selectedLocation);

    this.formattedAddress = description;
    console.log(this.formattedAddress);
  }

  locationInput: string = "";
  googleAutoCompleteItems: any[] = [];
  GoogleAutocomplete: any;

  onInputChange() {
    this.locationSelected = false;
    if (!this.formattedAddress.trim()) {
      this.googleAutoCompleteItems = [];
      return;
    }

    this.GoogleAutocomplete.getPlacePredictions(
      { input: this.formattedAddress },
      (predictions: any, status: any) => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK &&
          predictions
        ) {
          this.googleAutoCompleteItems = predictions;
        }
      },
    );

    console.log(this.googleAutoCompleteItems);
  }

  locationSelected = false;
  selectItem(item: any) {
    this.locationSelected = true; // ✅ user picked from list
    console.log(item);
    this.googleAutoCompleteItems = [];
    this.geocoder.geocode(
      {
        placeId: item.place_id,
      },
      (results: any, status: any) => {
        if (status === "OK" && results[0]) {
          this._ngZone.run(() => {
            // this.profileData.address_line = results[0].formatted_address;

            // this.locationSelected = true;
            let location_set: any = JSON.stringify(results[0].geometry);
            location_set = JSON.parse(location_set);
            let position = {
              lat: results[0].geometry.location.lat,
              lng: results[0].geometry.location.lng,
            };
            this.lat = location_set.location.lat;
            this.lng = location_set.location.lng;
            console.log(this.lat, this.lng);
            console.log("Latitude & Langitude", position);
            this.updateMapCoordinates(this.lat, this.lng, item.description);
            this.storeLocation(
              results[0].address_components,
              results[0].formatted_address,
              item.description,
            );
          });
        }
      },
    );
  }

  /**
   * Update map center and marker without recreating the google map instance.
   * lat/lng can be numbers or numeric strings.
   * opts: { zoom?: number, animate?: boolean } - animate isn't used (Google Maps JS has no built-in smooth pan),
   * but we keep opts for future extension.
   */
  updateMapCoordinates(
    lat: number | string,
    lng: number | string,
    description?: any,
  ) {
    const latNum = Number(lat);
    const lngNum = Number(lng);
    if (isNaN(latNum) || isNaN(lngNum)) {
      console.warn("updateMapCoordinates: invalid lat/lng", lat, lng);
      return;
    }

    // ensure map exists
    if (!this.map) {
      // If map hasn't been created yet, call initializeMap with these coords
      this.initializeMap({ latitude: latNum, longitude: lngNum }, description);
      return;
    }

    const latLng = new google.maps.LatLng(latNum, lngNum);
    this.map.setZoom(12);

    // center map
    this.map.setCenter(latLng);

    // create marker if missing
    if (!this.marker) {
      this.marker = new google.maps.Marker({
        map: this.map,
        draggable: true,
        position: latLng,
      });

      // add dragend listener once when marker created
      google.maps.event.addListener(this.marker, "dragend", (event: any) => {
        this.geocodePositionOverwrite(event.latLng);
      });
    } else {
      // move existing marker
      this.marker.setPosition(latLng);
    }

    // update geocoder results & component state
    if (!this.geocoder) this.geocoder = new google.maps.Geocoder();
    this.geocodePosition(latLng, description);

    // keep internal lat/lng in sync (string with fixed decimals if you prefer)
    this.lat = latNum.toFixed ? latNum.toFixed(6) : latNum;
    this.lng = lngNum.toFixed ? lngNum.toFixed(6) : lngNum;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }

  onPost() {
    let obj = {
      member_hash: this.parentdata.memberHash,
      address_hash: this.parentdata.addressInfo.hash_id,
      landmark: this.landmark,
      street_name: this.streetName,
      house_no: this.houseNumber,
      city: this.selectedLocation.city,
      state: this.selectedLocation.state,
      country: this.selectedLocation.country,
      zip: this.selectedLocation.zip,
      lat: this.lat,
      lng: this.lng,
      address_line: this.formattedAddress,
      service_mode: this.parentdata.addressInfo.service_mode,
      status: 1,
      created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      phone: this.phone,
      country_code: this.contactselectedCountryCode.dial_code,
    };

    Object.keys(obj).forEach((key) => {
          if (
            (obj as any)[key] === null ||
            (obj as any)[key] ===
              undefined ||
            (obj as any)[key] === "" ||
            (obj as any)[key] === "null"
          ) {
            delete (obj as any)[key];
          }
        });
    
    console.log(obj);

    this.loader.showLoader = true
    this._apiService.editMemberAddress(obj)
    
  }
}
